import { render, staticRenderFns } from "./SurchargeLinkedAccountsForm.vue?vue&type=template&id=6d782dd2&"
import script from "./SurchargeLinkedAccountsForm.vue?vue&type=script&lang=js&"
export * from "./SurchargeLinkedAccountsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports